<template>
  <div class="feedback-buttons">
    <el-button :icon="iconGood" @click="toggleIcon('good')"></el-button>
    <el-popover
        placement="right"
        width="330"
        trigger="click"
        v-model="popVisible"
    style="margin: 0 10px">
      <div class="top-buttons">


        <el-checkbox-group v-model="checkboxGroup" style="margin-bottom: 10px" >
          <el-checkbox label="分类错误" border></el-checkbox>
          <el-checkbox label="识别不准" border></el-checkbox>

        </el-checkbox-group>
        <el-button icon="iconfont icon-suggest" @click="ifInput=!ifInput">我要吐槽</el-button>
      </div>

       <el-input
          v-if="ifInput"
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
          v-model="textarea">
      </el-input>
      <div style="float: right;margin-top: 10px">
        <el-button type="primary" @click="commit">提交</el-button>
      </div>

    <el-button slot="reference" :icon="iconBad" @click="toggleIcon('bad')"></el-button>
    </el-popover>
    <el-button v-if="this.iconOther" :icon="iconOther" ></el-button>
  </div>
</template>

<script >
// 其他图标状态


export default {

  components: {},
  props:['icontype'],
  data() {

    return {
      checkboxGroup:[],
      checked1:false,
      checked2:false,
      popVisible:false,
      textarea:'',
      ifInput:false,
      iconOther:this.icontype,
      // 其他图标状态
      iconGood: 'iconfont icon-good',
      iconBad: 'iconfont icon-bad',

      originalIcons: {
        good: 'iconfont icon-good',
        bad: 'iconfont icon-bad',

      },
      toggleIcons: {
        good: 'iconfont icon-good-fill',
        bad: 'iconfont icon-bad-fill',

      }
    }
  },


  methods: {
    commit(){
      this.popVisible=false
      this.$message.success("提交成功！感谢您的建议")
    },
    toggleIcon(type) {
      if (type === 'good') {
        this.iconGood = this.iconGood === this.originalIcons.good ? this.toggleIcons.good : this.originalIcons.good;
      } else if (type === 'bad') {
        this.iconBad = this.iconBad === this.originalIcons.bad ? this.toggleIcons.bad : this.originalIcons.bad;
      } else if (type === 'copy') {
        this.iconCopy = this.iconCopy === this.originalIcons.copy ? this.toggleIcons.copy : this.originalIcons.copy;
      }
    },
  }
}
</script>

<style scoped>

.top-buttons {
  margin-bottom: 10px;
}
</style>
